import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import ArgonDashboard from "./plugins/argon-dashboard";
import { BootstrapVue } from "bootstrap-vue";
import * as VueThreejs from "vue-threejs";
import axios from "axios";
import VueAxios from "vue-axios";
import VueBarcode from "@chenfengyuan/vue-barcode";
import Chartist from "chartist";
import { BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

Vue.use(BootstrapVueIcons)
// import "./vue-excel"
// import "@/plugins/vueprinter";

import MaterialDashboard from "./material-dashboard";
Vue.component(VueBarcode.name, VueBarcode);
Vue.use(MaterialDashboard);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(VueThreejs);
Vue.use(BootstrapVue);
Vue.use(ArgonDashboard);

Vue.prototype.$Chartist = Chartist;

new Vue({
  router,
  data: {
    Chartist: Chartist
  },
  render: h => h(App)
}).$mount("#app");
